package com.anjuros.website.templates.template8.modules

import com.anjuros.website.templates.template8.util.ResKey


enum class Template8OpeningHours(
   val day:ResKey,
    val openingTime:String
) {

    MONDAY_CLOSED(
        day = ResKey.TEMPLATE8_MON,
        openingTime = "Closed"
    ),

    TUE_THU(
        day = ResKey.TEMPLATE8_TUE_THU,
        openingTime = "3pm-11pm"
    ),

    FRI_SAT(
        day = ResKey.TEMPLATE8_FRI_TO_SAT,
        openingTime = "2pm-1am"
    ),

    SUNDAY(
        day = ResKey.TEMPLATE8_SUN,
        openingTime = "2pm-10pm"
    );
}